import styled, { css } from 'styled-components';
import { GridAlignment } from '../Common/types';
import { mq, ResponsiveStyle } from '../Common/boxUtils';
import { listResetCss } from '../Common/listResetCss';

export type GridContainerTemplate = {
  minWidth: string;
  template: string;
};

type HeightProps = {
  $height?: 'full';
};

const heightCss = css<HeightProps>`
  ${({ $height }) =>
    $height === 'full' &&
    css`
      height: 100%;
    `}
`;

type StyledGridProps = HeightProps & {
  $gridTemplateColumns?: ResponsiveStyle<string>;
  $containerTemplates: GridContainerTemplate[];
  $gridAutoRows?: ResponsiveStyle<string>;
  $rowGap?: ResponsiveStyle<string>;
  $columnGap?: ResponsiveStyle<string>;
  $align?: ResponsiveStyle<GridAlignment>;
  $justifyItems?: ResponsiveStyle<GridAlignment>;
};

export const StyledGrid = styled.div<StyledGridProps>`
  display: grid;
  ${listResetCss}
  ${heightCss}

  ${props =>
    mq({
      gridTemplateColumns: props.$gridTemplateColumns,
      gridAutoRows: props.$gridAutoRows,
      rowGap: props.$rowGap,
      columnGap: props.$columnGap,
      alignItems: props.$align,
      justifyItems: props.$justifyItems,
    })}

  ${({ $containerTemplates }) =>
    $containerTemplates.map(
      ({ minWidth, template }) => css`
        @container (min-width: ${minWidth}) {
          grid-template-columns: ${template};
        }
      `
    )}
`;

export const StyledGridSizeContainer = styled.div<HeightProps>`
  container-type: inline-size;
  width: 100%;
  ${heightCss}
`;

type StyledGridSpanProps = {
  $gridColumn?: string;
  $gridRow?: string;
};

export const StyledGridSpan = styled.div<StyledGridSpanProps>`
  display: grid;
  min-width: 0;
  ${({ $gridColumn }) =>
    $gridColumn &&
    css`
      grid-column: ${$gridColumn};
    `}
  ${({ $gridRow }) =>
    $gridRow &&
    css`
      grid-row: ${$gridRow};
    `}
`;
